export default __webpack_public_path__ + "static/media/grab-logo.30a7cdac.webp";